import { ChevronLeft, ChevronRight, X } from 'lucide-react';

interface SidebarTopControlsProps {
  /** Closes the mobile drawer (X button). */
  onClose: () => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
}

/**
 * The mobile-drawer header (logo + close button) and desktop collapse
 * toggle that sit at the top of every admin-family sidebar. Pure
 * extraction from AdminSidebar/SuperAdminSidebar, which were carrying
 * byte-identical copies of this markup — shared here so a style/behaviour
 * fix in one sidebar can't silently drift from the other.
 */
export default function SidebarTopControls({ onClose, isCollapsed, onToggleCollapse }: SidebarTopControlsProps) {
  return (
    <>
      {/* Mobile Header */}
      <div className="lg:hidden flex items-center justify-between p-4 border-b border-gray-200 dark:border-tutara-dark-mode-border">
        <div className="flex items-center">
          <img
            src="/logos/icon.png"
            alt="Tutara"
            className="h-8 w-8"
          />
        </div>
        <button
          onClick={onClose}
          className="p-2 hover:bg-gray-100 dark:hover:bg-tutara-dark-mode-bg rounded-lg"
        >
          <X className="h-5 w-5 text-gray-600 dark:text-gray-400" />
        </button>
      </div>

      {/* Desktop Collapse Toggle */}
      <div className="hidden lg:flex items-center justify-end p-2 border-b border-gray-200 dark:border-tutara-dark-mode-border">
        <button
          onClick={onToggleCollapse}
          className="p-2 hover:bg-gray-100 dark:hover:bg-tutara-dark-mode-bg rounded-lg transition-colors"
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? (
            <ChevronRight className="h-5 w-5 text-gray-600 dark:text-gray-400" />
          ) : (
            <ChevronLeft className="h-5 w-5 text-gray-600 dark:text-gray-400" />
          )}
        </button>
      </div>
    </>
  );
}
